module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[65]308.a6bd18f.woff2";